// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const LineFilterModeValues = ["SHOW_ALL", "HIDE_CHILD_LINES", "HIDE_PARENT_LINES"] as const;

export type LineFilterMode = (typeof LineFilterModeValues)[number];

export const getLineFilterModeLabels = () => ({
	SHOW_ALL: t("show_all"),
	HIDE_CHILD_LINES: t("hide_child_lines"),
	HIDE_PARENT_LINES: t("hide_parent_lines"),
});

export const getLineFilterModeLabel = (value: LineFilterMode): string => {
	return getLineFilterModeLabels()[value];
};
